module.exports = __webpack_public_path__ + "img/inClass.3156956a.gif";